export default ({ store, redirect, route }) => {
    if (!store.getters.user) {
        return redirect('/login')
    }
    if (store.getters.canAgent) {
        return
    }
    if (store.getters.isBroker) {
        return redirect(302, '/broker')
    }
    if (store.getters.isHr) {
        const group = store.getters.group
        if (group && group.slug) {
            return redirect(302, `/group/${group.slug}/dashboard`)
        }
    }
    return redirect(302, '/survey/', route.query)
}
